const TicketCreditsIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_19580_5329)">
            <path
                d="M1.98226 8.33301H18.0164C18.0164 8.33301 18.8498 8.33301 18.8498 9.16634V18.333C18.8498 18.333 18.8498 19.1663 18.0164 19.1663H1.98226C1.98226 19.1663 1.14893 19.1663 1.14893 18.333V9.16634C1.14893 9.16634 1.14893 8.33301 1.98226 8.33301Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.23242 6.65904L3.46742 5.27654C3.48579 5.16863 3.52523 5.06539 3.5835 4.97273C3.64177 4.88006 3.71773 4.79979 3.80704 4.73648C3.89634 4.67318 3.99724 4.62809 4.10397 4.6038C4.21071 4.5795 4.32118 4.57647 4.42909 4.59488L17.7274 6.88571"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.62354 2.77765L6.14437 1.37682C6.22137 1.1698 6.37741 1.00181 6.5782 0.909773C6.77899 0.817737 7.00811 0.809182 7.2152 0.885988L18.3227 5.01932"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.90001 10.416L11.9836 12.4996L9.90001 14.5832L7.81641 12.4996L9.90001 10.416Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.31592 16.667H14.8993"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_19580_5329">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default TicketCreditsIcon;

